//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import Filters from './TableFilters.vue';

import tableConfig from './tableConfig';
import actionsConfig from './actionsConfig';

export default {
  components: { Filters },

  data() {
    return {
      tableConfig,
      actionsConfig,
      loader: false,
      constant,
      getMessagesTimerId: null,
      editingDevice: {
        show: false,
        data: {},
        isCreating: false,
      },
      selection: [],
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('userDevices', ['page', 'pages', 'data', 'sort']),
  },

  beforeDestroy() {
    if (this.getMessagesTimerId) {
      clearInterval(this.getMessagesTimerId);
    }
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('userDevices', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
      deleteDeviceAction: 'deleteDevice',
    }),
    ...mapActions('userDevices', {
      setOffersFilters: 'setFilters',
    }),

    async loadData(data = {}) {
      const userId = this.$route.params.id;
      this.setGeneralLoader(true);
      await this.loadDataAction({
        ...data,
        userId,
      });
      this.setGeneralLoader(false);
    },

    async deleteDevice(id) {
      this.setGeneralLoader(true);
      try {
        await this.deleteDeviceAction(id);
        this.setSuccessNotification('Device deleted');
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.loadData();
      this.setGeneralLoader(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    getStatusColor(id) {
      switch (id) {
        case 0:
          return 'success--text';
        case 1:
          return 'warning--text';
        case 2:
          return 'error--text';
        default:
          return '';
      }
    },

    setPage(value) {
      this.setPageAction(value);

      // SINGLE TABLE COMPONENT
      // const query = { page: value };
      // this.$router.replace({ query });

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },
  },
};
